import lib from "./../js-lib/lib.js";
import { _$ } from "./../js-lib/jsr.js";

const uniqueID = () => {
  return Math.floor(Math.random() * Date.now())
  }

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const createButton = () => {
  // Add Person Button
  let createPerson = _$.create(
    `<button class="frm--input">Add Teacher</button>`,
    lib.id('frm_section1'),
    11
  );

  createPerson.addEventListener("click", (e) => {
    e.preventDefault();
    buildPerson();
  });
}

let i = -1;

    // PERSON Fields
    let personFields = `
    <div class="remove">x</div>
    <input type="text" data-name="name" placeholder="Additional teacher name"/>
    <div class="group person-group">
      <div class="is-email">
        <input type="text" data-name="email" placeholder="Additional teacher email"/>
      </div>
      <div class="gfield_contains_required is-number">
        <input type="text" data-name="number" placeholder="Additional teacher mobile" required/>
      </div>
      <div class="gfield_contains_required is-dietary">
        <input type="text" data-name="dietary" placeholder="Additional teacher dietary requirements"/>
      </div>
      <div class="is-accessibility">
        <input type="text" data-name="accessibility" placeholder="Additional teacher accessibility needs"/>
      </div>
    </div>`;

const buildPerson = () => {
  i++;

  if(window.state.dataPeopleList.length < 4) {
    createButton();
  } else {
    _$.create(
      ``,
      lib.id('frm_section1'),
      11
    );
  }

  let el = _$.create(
    `<div class="person" data-index="${i}">${personFields}
    </div>`,
    lib.id('people'),
    uniqueID()
  );


  let inputName = el.querySelectorAll('[data-name]');

  inputName.forEach((item) => { 
    item.addEventListener('input', () => {
      validateFields(el, item);
    });
  })

  window.state.peopleList.push(el);

  // On Page Load
  setTimeout(() => { 
    validateFields(el);
  }, 200);
  

  el.querySelector(".remove").addEventListener("click", (e) => {
    el.remove();

    // Remove Item from Array
    window.state.dataPeopleList.splice(el.dataset.index, 1);
  });
};

const validateFields = (el, item) => {
  let inputName = el.querySelector('[data-name="name"]');

  if(inputName.value.trim().length < 1) {
    // is empty
    el.querySelector('.group').style.display = 'none';
  } else {
    // has content
    el.querySelector('.group').style.display = 'block';


    if(el.querySelector('[data-name="email"]').value.length > 0) {
      // Email Validation
      if(el.querySelector('[data-name="email"]')) {
        if(validateEmail(el.querySelector('[data-name="email"]').value)) {
          let val = _$.create(``, el.querySelector('.is-email'), 11243); // Remove validation
        } else {
          let val = _$.create(
            `<div id="validation_message_12_1" class="gfield_description validation_message gfield_validation_message">
              Email is invalid.
            </div>`, el.querySelector('.is-email'), 11243 );
        };
      }
    } else {
        let val = _$.create(``, el.querySelector('.is-email'), 11243); // Remove validation
    }

    // Phone Number Validation
    if(el.querySelector('[data-name="number"]').value !== '') {
      let val = _$.create(``, el.querySelector('.is-number'), 112433); // Remove validation
    } else {
      let val = _$.create(
        `<div id="validation_message_12_1" class="gfield_description validation_message gfield_validation_message">
          Number is a required field.
        </div>`, el.querySelector('.is-number'), 112433 );
    };

    // Dietary Validation
    if(el.querySelector('[data-name="dietary"]').value !== '') {
      let val = _$.create(``, el.querySelector('.is-dietary'), 11245); // Remove validation
    } else {
      let val = _$.create(
        `<div id="validation_message_12_1" class="gfield_description validation_message gfield_validation_message">
          Dietary requirements is a required field.
        </div>`, el.querySelector('.is-dietary'), 11245);
    };
  


  };
}


const frm_section1 = {
  scope: () => {},
  render: () => {
    const gform = lib.qs(".gform_wrapper");

    if (!gform) {
      return;
    }

    let data = [];

    // Parent People Container
    let people = _$.create(`<div id="people"></div>`, lib.id('frm_section1'), uniqueID());

    // Individual Element
    // window.state.peopleList.push(
    //   _$.create(`<div class="person"></div>`, "#people", 1)
    // );


    createButton();
      

    // // Add Person Button
    // let checkData = _$.create(
    //   `<button class="input">Check Data</button>`,
    //   "#frm_section1",
    //   1
    // );

    let collect = "";

    const dataCollection = () => {
      collect = "";

      lib.qsa(".person").forEach((a, z) => {
        a.querySelectorAll("input").forEach((b, x) => {
          collect +=  "\n > " + b.value;

          if (!window.state.dataPeopleList[z]) {
            window.state.dataPeopleList[z] = [];
          }

          if (!window.state.dataPeopleList[z][x]) {
            window.state.dataPeopleList[z][x] = [];
          }

          window.state.dataPeopleList[z][x] = b.value;

          // if (x < 2) {
          //   collect += "\n";
          // }
        });

        // if (z > 0) {
          collect += "\r \n ------- \r";

          console.error(collect);
        //}
      });

      lib.qs(".frm_section1_submit textarea").value = collect;
    };

    // Re-Render on Submit
    lib
      .qs('.gform_footer input[type="submit"]')
      .addEventListener("click", (e) => {
        e.target.style.pointerEvents = "none";
        dataCollection();
        setTimeout(() => {
          frm_section1.render(); // Re-render form once clicked
        }, 11000);
      });


    // Dont add Fields if dataPeopleList exists
    if (!window.state.dataPeopleList) {
      buildPerson();
    }

    // Create new fields from dataPeopleList]
    if (window.state.dataPeopleList) {
      window.state.dataPeopleList.forEach(() => {
        buildPerson();
      });

      // Load in New Field Data based on Array
      window.state.dataPeopleList.forEach((items, a) => {
        items.forEach((item, b) => {
          lib.qsa(".person")[a].querySelectorAll("input")[b].value = item;
        });
      });
    }
  },
};

export { frm_section1 as default };
